import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { lazyInject } from '@app/shared/decorators/lazy-inject.decorator';
import { I18n } from '@app/i18n/strings-keys';
import { I18nService } from '@app/shared/services/i18n/i18n.service';

@Component({
  selector: 'xea-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NotFoundComponent implements OnInit {
  @lazyInject(I18nService) public i18nService: I18nService;
  public I18n = I18n;
  public notFoundTitle: string = I18n.CommonErrors.NotFound404;
  public notFoundUrlMsg: string = I18n.CommonErrors.InvalidUrlMsg;
  public notFoundUrl: string = '';

  public ngOnInit() {
    this.notFoundUrl = window.location.href;
  }
}
